<template>
	<div class="footer bg-white bottomStack" v-if="paperData" :class="setTabFixed  ? 'fixed-bottom' : ''">
		<div class="divider"></div>
		<div class="container container--narrow pdb-0">
			<div class="d-flex align-items-center justify-content-between pdt-9 pdb-10">
				<div class="d-flex align-items-baseline " v-if="isCharged">
					<div class="t-body-6 pdr-4">{{paperData.goods.currency.key || 'USD'}}</div>
					<div class="t-headline5 pdr-8  t-line-h-32">{{$n(paperData.goods.paymentPrice)}}</div>
				</div>
				<div class="d-flex align-items-baseline " v-else> 
					<div class="t-headline5 pdr-8 t-line-h-32">{{$t('1010')}}</div>
				</div>
				<div v-if="!examineeId">
					<button class="mdc-button mdc-button--raised bg-mainBtn t-color-mainBtnText "
							v-if="isCharged"
							@click="buyExam()" @keypress="buyExam()" tabindex="0">
						<div class="mdc-button__ripple"></div>
						<span class="mdc-button__label t-body2 font-r">{{$t('1002')}}</span>
					</button>
					<button class="mdc-button mdc-button--raised bg-mainBtn t-color-mainBtnText "
							v-else @click="buyExam()" @keypress="buyExam()" tabindex="0">
						<div class="mdc-button__ripple"></div>
						<span class="mdc-button__label t-body2 font-r">{{$t('1011')}}</span>
					</button>
				</div>
				<div v-else>
					<div v-for="(action, index) in actions" :key="index">
						<button class="mdc-button mdc-button--raised bg-mainBtn t-color-mainBtnText "
									:disabled="setButtonDisabled(action)" @click="examAction(action)" @keypress="examAction(action)" tabindex="0">
								<div class="mdc-button__ripple"></div>
								<span class="mdc-button__label t-body2 font-r">{{setButtonActionName(action)}}</span>
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import ViewHeader from './Header.vue'
import {MDCRipple} from '@material/ripple'
export default {
	props: ['setTabFixed'],
	extends: ViewHeader,
	mounted() {
		this.setMaterialUi()
	},
	methods: {
		setMaterialUi() {
			const buttonRipple = [].map.call(document.querySelectorAll('.mdc-button'), function(el) {
				let button = new MDCRipple.attachTo(el)
				return button
			})
		},
	}
}
</script>

<style>

</style>